/** Populate only from verified company records. Missing fields block release in
 * the package checklist; they must never be invented or shown as placeholders. */
export interface BusinessDisclosures {
  legalName: string | null;
  cin: string;
  grievanceOfficerName: string | null;
  grievanceOfficerDesignation: string | null;
  grievanceEmail: string | null;
  grievancePhone: string | null;
}
export const BUSINESS_DISCLOSURES: BusinessDisclosures = {
  legalName: "OMKARA NUTRACEUTICALS PRIVATE LIMITED",
  cin: "U21001UT2025PTC019809",
  grievanceOfficerName: null,
  grievanceOfficerDesignation: null,
  grievanceEmail: null,
  grievancePhone: null,
};
export const PRIVACY_EMAIL = "admin@truwe.in";
export const SUPPORT_EMAIL = "hello@truwe.in";
